import { AppService } from '@ajin/services/app.service';
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from './auth.service';


function getDynamicHeaderName(): string {
	const seed = new Date().getUTCDate().toString();
	const obfuscated = btoa("zjt-" + seed).replace(/=/g, "").toLowerCase();
	const _v = atob('WC1WZXJzaW9u'); //'X-Version'
	var _key = `${_v}-${obfuscated}`;
	return _key;
}

export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
	const authService = inject(AuthService);
	const _app = inject(AppService);

	const timestamp = Date.now().toString();
	const hash = CryptoJS.HmacSHA256(timestamp, '3160c0fa-e7dc-4761-8a08-f78e85c88e7e').toString();
	const signature = `${timestamp}.${hash}`;

	var _vKey = getDynamicHeaderName();

	if (req.url.indexOf('viacep') !== -1) {
		return next(req);
	}

	if (req.url.indexOf('s3.amazonaws.com') !== -1) {
		return next(req);
	}

	if (req.url.indexOf('ajinsoft.s3.sa-east-1.amazonaws.com') !== -1) {
		return next(req);
	}

	if (req.url.indexOf('https://api.ipify.org?format=json') !== -1) {
		return next(req);
	}

	if (req.headers.has('X-Skip-Auth')) {
		const cleanReq = req.clone({
			headers: req.headers
				.delete('X-Skip-Auth')
				.set(_vKey, signature)
		});

		return next(cleanReq);
	}

	let newReq = req.clone();
	let linkKey = localStorage.getItem('link_key') ?? '';

if (linkKey === 'undefined' || linkKey === 'null')
    linkKey = '';

	if (authService.token) {
		newReq = req.clone({
			headers: req.headers
				.set('Authorization', 'Bearer ' + authService.token)
				.set(_vKey, signature)
		});
	}
	else if (linkKey) {
		newReq = req.clone({
			headers: req.headers
				.set('LinkKey', linkKey)
				.set(_vKey, signature)
		});
	}
	else {
		newReq = req.clone({
			headers: req.headers
				.set(_vKey, signature)
		});
	}

	return next(newReq).pipe(
		catchError((error) => {
			if (error instanceof HttpErrorResponse && error.status === 401) {
				authService.signOut();
			}

			return throwError(error);
		})
	);
};
